import { render, staticRenderFns } from "./sp-video.vue?vue&type=template&id=7c9f6e5d"
var script = {}
import style0 from "./sp-video.vue?vue&type=style&index=0&id=7c9f6e5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports